<script setup>
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps({
  icon: String,
  color: {
    type: String,
    default: '#000'
  },
  size: {
    type: [Number, String],
    default: '24'
  }
});

// One async wrapper per icon name, kept for the life of the module: resolving
// through a computed is what lets a bound name switch at runtime, and reusing
// the wrapper stops a toggled icon from remounting on every flip.
const wrappers = new Map();

const icon = computed(() => {
  const name = props.icon;
  if (!name) return null;

  if (!wrappers.has(name)) {
    wrappers.set(name, defineAsyncComponent(() => import(`./Icon${name}.vue`)));
  }

  return wrappers.get(name);
});
</script>

<template>
  <icon :color="color" :size="size" />
</template>
